var newPieWidth = 0;
var myCharts    = [];



window.pieChart = function(canvasElId, dataUrl){
    
	axios.get(dataUrl)
		.then(function (response) {
            var name = canvasElId.replace("myChart_","");
            if($(window).width() < 420){
                thisEl.attr("width", newPieWidth);
                thisEl.attr("height", newPieWidth);
                thisEl.css("max-width", newPieWidth + "px;");
                thisEl.css("width", newPieWidth + "px;");
            }
            
            myCharts[name] = pie_use(canvasElId, response.data.pie.labels, response.data.pie.values, response.data.pie.colors, response.data.pie.urls, function(tooltipItem, data) {
                return " " + data.labels[tooltipItem.index];
            });
            
            if(response.datafree <= 0){
                $(this).parents(".gridbox").addClass('maxReached');
            }else{
                $(this).parents(".gridbox").removeClass('maxReached');
            }
        }
    );
}


function pie_use(id, labels, data, colors, urls, labelFunc = ""){
    var ctx = document.getElementById(id).getContext("2d");
    
    var options = {
        cutoutPercentage: 54,
        responsive: true,
        maintainAspectRatio: true,
        legend: {
                display: false,
        },
        tooltips: {
            mode: 'label',
            fontSize: 80,
            callbacks: {
                    label: labelFunc
            },
        },
        onHover: function(evt, item) {
            
            if(typeof urls !== 'undefined' && urls.length > 0){
                $("#" + id).css("cursor", "pointer");
            }
        },
        onClick: (evt, item) => {
            if(typeof urls !== 'undefined' && typeof urls[item[0]._index] !== 'undefined'){
                window.open(urls[item[0]._index],"_self");
            }
        }
    };
    
    var chart = new Chart(ctx,{
        type: 'doughnut',
        data: {
                datasets: [{
                        data: data,
                        backgroundColor: colors,
                        borderWidth: 1,
                        borderColor: '#0F1035'
                }],
                labels: labels
        },
        options: options
    });		
    
    
    return chart;
}